import { useEffect, useReducer } from 'react'
import { loadStoredState, saveStoredState } from './persistence.js'
import { createInitialState, guidedObservationReducer } from './state.js'

export default function useGuidedObservation() {
  const [state, dispatch] = useReducer(guidedObservationReducer, undefined, () => loadStoredState() || createInitialState())
  useEffect(() => { saveStoredState(state) }, [state])
  return [state, dispatch]
}
